export interface ChangelogEntry {
	id: string;
	date: Date;
	title: string;
	description: string;
	type: "feature" | "improvement" | "fix";
}

export const changelog: ChangelogEntry[] = [
	{
		id: "2026-09-10-sava-node-links",
		date: new Date("2026-09-10"),
		title: "Sava's answers link straight into your graph",
		description:
			"Every person and company Sava names is now a link. Hover one for the same card the graph shows — with clickable emails and profile links — or click to open its details and center it on the canvas. The graph's own hover card is reachable now too: move onto it and its actions are yours.",
		type: "feature",
	},
	{
		id: "2026-08-13-connections-browser",
		date: new Date("2026-08-13"),
		title: "A connections browser for your busiest contacts",
		description:
			"Highly connected entities no longer slow the editor down. The node panel now previews the most recent connections and opens a searchable browser for the full list — find any relationship by name, type, or summary, no matter how large the network.",
		type: "improvement",
	},
	{
		id: "2026-08-11-faster-graph-loading",
		date: new Date("2026-08-11"),
		title: "Faster graph loading, with company",
		description:
			"Large networks now load significantly faster — duplicate data fetching is gone and rendering work is batched. While your constellation assembles, a new loading experience shows real progress and live node counts.",
		type: "improvement",
	},
	{
		id: "2026-07-18-email-invites",
		date: new Date("2026-07-18"),
		title: "Invite teammates by email",
		description:
			"Organization admins can now invite people by email (as a member or admin) and manage pending invitations — resend or revoke them at any time. Shareable invite links and manual join requests have been retired in favor of secure, email-bound invitations.",
		type: "feature",
	},
	{
		id: "2026-02-03-linkedin-import",
		date: new Date("2026-02-03"),
		title: "LinkedIn Data Import",
		description:
			"Import your LinkedIn connections, work history, education, and skills directly from your data export to build your professional network graph.",
		type: "feature",
	},
	{
		id: "2025-12-10-kanban",
		date: new Date("2025-12-10"),
		title: "Kanban Board View",
		description:
			"Organize and track your tasks with a Kanban board interface for better workflow management.",
		type: "feature",
	},
	{
		id: "2025-12-10-csv-import",
		date: new Date("2025-12-10"),
		title: "CSV Import",
		description: "Import nodes from CSV files to quickly build your graph.",
		type: "feature",
	},
	{
		id: "2025-12-10-hover-dimming",
		date: new Date("2025-12-10"),
		title: "Hover Dimming for Graph Nodes",
		description:
			"Hovering over a node now dims unconnected nodes and edges, making it easier to see immediate connections.",
		type: "improvement",
	},
	{
		id: "2025-12-10-whats-new",
		date: new Date("2025-12-10"),
		title: "What's New Notifications",
		description: "Stay updated with the latest features and improvements.",
		type: "feature",
	},
];
